import { useEffect, useState } from 'react'
import { Button, ModalForm } from '../../../../../components'
import { debug } from '../../../../../settings'
import { getOrderItemInfoDpos } from '../../../../../lib-pos/transformOrders'
import { ChangeQty } from '../../../../shopPage2/components/TestOrder/compos'
import { getPriceStr } from '../../../../../lib/utils'
import { onlposUpdateOrderStatus2 } from '../../../lib/api-onlpos'

export function OrderEditMoal(props) {
  const {
    visible,
    setIsVisible,
    selectedTableInfo,
    selectedOrder,
    orderList,
    shopInfo,
    updateOrderList,
  } = props

  const [isLoading, setIsLoading] = useState(false)
  const [orderItem, setOrderItem] = useState(null)
  const [itemCount, setItemCount] = useState(1)
  const [totalPrice, setTotalPrice] = useState(0) // 옵션 포함함

  const [orderObj, setOrderObj] = useState(null)

  useEffect(() => {
    // console.table([selectedOrder])
    const idx = orderList.findIndex((o) => o.orderId === selectedOrder.orderId)
    const orderObj_ = orderList[idx]
    setOrderObj(orderObj_)
    const orderInfo = orderObj_.orderData.orderList[selectedOrder.index]

    const { itemAmt, itemTxt, optTxt } = getOrderItemInfoDpos({
      order: orderInfo,
    })

    if (debug) {
      console.log(
        '='.repeat(50),
        selectedOrder.itemName || selectedOrder.optionItemName,
        selectedOrder.index,
      )
      console.table(orderObj_.orderData?.orderList)
      // console.log('-'.repeat(50), 'selectedOrder')
      // console.table([selectedOrder])

      // console.log('-'.repeat(50), 'orderInfo')
      // console.table([orderInfo])
      console.log(orderInfo.qty, itemAmt, itemTxt, optTxt)
    }
    setTotalPrice(itemAmt / orderInfo.qty)
    setOrderItem(orderInfo)
    setItemCount(orderInfo.qty)
  }, [orderList, selectedOrder])

  const onSubmit = async (mode) => {
    try {
      setIsLoading(true)

      const newOrderList = [...orderObj.orderData?.orderList]

      console.log('before: index =', selectedOrder.index)
      console.table(newOrderList)

      if (mode === 'edit') {
        const newOrder = {
          ...newOrderList[selectedOrder.index],
          qty: itemCount,
        }
        newOrderList.splice(selectedOrder.index, 1, newOrder)
      } else if (mode === 'del') {
        newOrderList.splice(selectedOrder.index, 1)
      } else {
        throw Error('INVALID ACCESS')
      }

      const newOrderData = {
        ...orderObj.orderData,
        orderList: newOrderList,
      }

      console.log('after')
      console.table(newOrderData.orderList)

      const params = {
        shopInfo,
        // shopId: shopInfo.shopId,
        tableCode: selectedTableInfo.tableCode,
        body: {
          orderData: JSON.stringify(newOrderData),
        },
      }

      let res = await onlposUpdateOrderStatus2(params)
      if (res.err) throw Error(res.err.message)
      await updateOrderList()
    } catch (e) {
      alert(e.message)
    } finally {
      setIsLoading(false)
      setIsVisible(false)
    }
  }

  // const onSubmitDel = async () => {
  //   try {
  //     setIsLoading(true)

  //     const newOrderList = [...orderObj.orderData?.orderList]

  //     // console.log('before: index =', selectedOrder.index)
  //     // console.table(newOrderList)

  //     newOrderList.splice(selectedOrder.index, 1)

  //     const newOrderData = {
  //       ...orderObj.orderData,
  //       orderList: newOrderList,
  //     }

  //     // console.log('after')
  //     // console.table(newOrderData.orderList)

  //     const params = {
  //       shopId: shopInfo.shopId,
  //       tableCode: selectedTableInfo.tableCode,
  //       body: {
  //         orderData: JSON.stringify(newOrderData),
  //       },
  //     }

  //     // console.log('params', params)

  //     let res = await onlposUpdateOrderStatus2(params)
  //     if (res.err) throw Error(res.err.message)
  //     await updateOrderList()
  //   } catch (e) {
  //     alert(e.message)
  //   } finally {
  //     setIsLoading(false)
  //     setIsVisible(false)
  //   }
  // }

  const allProps = {
    ...props,
    orderItem,
    itemCount,
    setItemCount,
    totalPrice,
    setTotalPrice,
  }

  const styles = {
    wrap: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      height: debug ? '30vh' : '60vh',
      overflowY: 'auto',
    },
    btnWrap: {
      display: 'flex',
      justifyContent: 'space-between',
    },
  }

  return (
    <ModalForm
      visible={visible}
      setIsVisible={setIsVisible}
      title="주문항목 수정"
      isLoading={isLoading}
      backdrop="static"
      mode="ONL_POS"
    >
      <div style={styles.wrap}>
        <OrderInfo {...allProps} />
      </div>

      {orderItem && (
        <div style={styles.btnWrap}>
          <Button
            variant="secondary"
            title="삭제"
            width="48%"
            onClick={() => onSubmit('del')}
          />

          <Button
            variant="primary"
            title="수정"
            width="48%"
            onClick={() => onSubmit('edit')}
            disabled={orderItem.qty === itemCount}
          />
        </div>
      )}
    </ModalForm>
  )
}

const OrderInfo = (props) => {
  const {
    orderItem,
    itemCount,
    setItemCount,
    totalPrice,
    gStyle,
    colors,
  } = props

  const styles = {
    wrap: { flex: 1 },
    subWrap: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginTop: 5,
    },
    sum: { ...gStyle.subtitle, color: colors.primary },
  }

  return (
    orderItem && (
      <div style={styles.wrap}>
        <div style={styles.subWrap}>
          <p style={{ ...gStyle.text, fontWeight: 600 }}>
            {orderItem.itemName}
          </p>
          <p style={{ ...gStyle.text, fontWeight: 600 }}>
            {getPriceStr(orderItem.price)} 원
          </p>
        </div>

        {orderItem.optionList.map((opt, i) => {
          return (
            <div style={{ ...styles.subWrap, marginLeft: 30 }} key={i}>
              <p style={gStyle.text}>{opt.optionItemName}</p>
              <p style={gStyle.text}>{getPriceStr(opt.price)} 원</p>
            </div>
          )
        })}

        <br />

        <div>
          <ChangeQty
            itemCount={itemCount}
            setItemCount={setItemCount}
            size="lg"
          />
        </div>

        <hr />

        <div style={styles.subWrap}>
          <p style={styles.sum}>합계</p>
          <p style={styles.sum}>{getPriceStr(totalPrice * itemCount)} 원</p>
        </div>
      </div>
    )
  )
}
